export const NEW_STATISTICS_SEARCH = 'NEW_STATISTICS_SEARCH';
export const STATISTICS_SEARCH = 'STATISTICS_SEARCH';
export const STATISTICS_RESET = 'STATISTICS_RESET';
